import { css } from "@emotion/react";
import { FONT_SIZE } from "../../constants/style";

interface LoaderInnerConetntProps {
  description: string;
}

const LoaderInnerConetnt = ({ description }: LoaderInnerConetntProps) => {
  return <div css={InnerConetnt}>{description}</div>;
};

const InnerConetnt = css`
  font-size: ${FONT_SIZE.xxsLarge};
`;

export default LoaderInnerConetnt;
